import { get, post } from "../../xhr/api";

/* export const login = (name,password) => {
    return post('api/login',{},{
        'name':name,
        'password':password
    }, false);
} */

export const login = (login_type, mobile, name, password) => {
  return post(
    "api/login",
    {},
    {
      login_type,
      mobile,
      name,
      password,
    },
  );
};

export const checkVerifications = () => {
  return get("api/user/verifications", {}, true);
};

export const logout = () => {
  return post("api/logout", {}, {}, true);
};

// OLD Registration API
export const register = ($data) => {
  return post("api/register", {}, $data, false);
};

export const registerSendOTP = (data = {}) => {
  return post("api/register/sendOTP", {}, data, false);
};

export const registerConfirmOTP = (data = {}) => {
  return post("api/register/confirmOTP", {}, data, false);
};

/* export const verify = (param) => {
  return get(`api/email/verify/${param}`, {}, false);
}; */


export const verify = (fullUrl) => {
  return get(fullUrl, {}, false);
};


export const getUser = () => {
  return get("api/user-profile", {}, true);
};

export const refresh = (data = {}) => {
  return post("api/check-token", {}, data, true);
};

export const editPassowrd = ($data) => {
  return post("api/edit-password", {}, $data, true);
};

export const forgotPassowrd = ($data) => {
  return post("api/forgot-password-mail", {}, $data, false);
};
export const forgotPassowrdPhone = ($data) => {
  return post("api/forgot-password-phone", {}, $data, false);
};
export const resetPassOtp = ($data) => {
  return post("api/reset-password-otp", {}, $data, false);
};
export const generateTokenForOtp = ($data) => {
  return post("api/generate-token-for-otp", {}, $data, false);
};

export const resetPassword = ($data) => {
  return post("api/reset-password", {}, $data, false);
};
export const checkResetPassValidty = ($data) => {
  return post("api/check-reset-password-validity", {}, $data, false);
};

export const edit_profile = ($data) => {
  return post("api/edit-profile", {}, $data, true);
};

export const verifyMobileSendOtp = ($data) => {
  return post("api/verify-mobile/sendOtp", {}, $data, false);
};
export const verifyMobileConfirmOtp = ($data) => {
  return post("api/validatePhone/confirmOtp", {}, $data, false);
};

export const loginAfterVerification = ($data) => {
  return post("api/login-after-verfication", {}, $data, false);
};

export const validateEmail = ($data) => {
  return post("api/validateEmail", {}, $data, false);
};
export const checkNationalId = ($data) => {
  return post("api/validateIdentity", {}, $data, false);
};

export const profileVerificationPhone = ($data) => {
  return post("api/profile-verification-phone", {}, $data, false);
};
export const profileVerificationEmail = ($data) => {
  return post("api/profile-verification-email", {}, $data, false);
};
export const profileConfirmOtp = ($data) => {
  return post("api/profile-confirm-otp", {}, $data, false);
};
export const uploadImages = ($data) => {
  return post("api/declaration-system/declarations/upload-attachments", {}, $data, false);
};
